document.addEventListener('DOMContentLoaded', function() {
    const paragraphs = document.querySelectorAll('.wp-site-blocks section p,.wp-site-blocks #main-header p');
    paragraphs.forEach(function(p) {
        if (!p.innerHTML.trim()) {
            p.remove();
        }
    });
});

